export default {
  featuredExperiences: 'Suositellut elämyksemme',
  searchAllExperiences: 'Hae kaikkia elämyksiä',
  searchAll: 'Hae kaikki',
  groupSize: 'Ryhmäkoko',
  eventSize: 'Tapahtuman koko',
  upTo: 'Enintään',
  whatWeDo: 'Mitä teemme',
  hostedBy: 'Isäntänä',
  whatsIncluded: 'Mitä sisältyy',
  avail: 'Saatavuus',
  whereWeAre: 'Missä olemme',
  experienceCalendar: 'Elämyskalenteri',
  experienceCancelled: 'Elämys peruutettu',
  experienceStartingPrice: 'Alkaen {{price}}',
  experienceTotalPrice: 'Yhteensä {{price}}',
  at: 'klo',
  viewPrivateSessAvailability: 'Näytä yksityisen istunnon saatavuus',
  selectDuration: 'Kesto',
  selectStartTime: 'Alkamisaika',
  selectSession: 'Valitse istunto',
  sessionsCount: '{{count}} ajankohtaa — valitse aika',
  noAvailability: 'Ei saatavuutta',
  select: 'Valitse',
  slotLeft: '{{remainSlots}} paikka jäljellä',
  slotsLeft: '{{remainSlots}} paikkaa jäljellä',
  spotsLeft: '{{count}} jäljellä',
  spotsLeftAriaLabel: '{{count}} paikkaa jäljellä',
  bookExperience: 'Varaa elämys',
  book: 'Varaa',
  learnMore: 'Lue lisää',
  apply: 'Käytä',
  maxPartySizes: 'Enintään {{maxGroupSize}} paikkaa ryhmää kohti',
  maxPartySize: 'Enintään {{maxGroupSize}} paikka ryhmää kohti',
  selectSessionValidation: 'Valitse istunto',
  selectParticipantValidation: 'Valitse osallistujat',
  selectDateValidation: 'Valitse päivämäärä',
  reminders: 'Muistutukset',
  seeOtherDates: 'Näytä muut päivämäärät',
  location: 'Sijainti',
  about: 'Tietoja',
  allExperiences: 'Kaikki elämykset',
  soldOut: 'Loppuunmyyty',
  addOns: 'Lisäpalvelut',
  reviews: 'Arvostelut',
  reviewSingular: 'arvostelu',
  reviewPlural: 'arvostelua',
  dateOfExperience: 'Elämyksen päivämäärä',
  readLess: 'Lue vähemmän',
  readMore: 'Lue lisää',
  seeMore: 'Näytä lisää',
  details: 'Tiedot',
  durationHour: 'tunti',
  durationHours: 'tuntia',
  durationMinutes: 'min',
  theFollowingVideoDoesNotContainAnyAudio: 'Seuraava video ei sisällä ääntä',
  by: 'Tekijä',
  chooseATime: 'Valitse aika kohteelle {{title}}',
  amenities: 'Mukavuudet',
  ticketSalesOpenIn: 'Lippujen myynti alkaa',
  ticketSalesOpen: 'Lippujen myynti on auki',
  ticketSalesCloseIn: 'Lippujen myynti sulkeutuu',
  ticketSalesClose: 'Lippujen myynti sulkeutuu',
  ticketSalesClosed: 'Lippujen myynti päättynyt',
  comingSoon: 'Tulossa pian',
  inPartnershipWith: 'Yhteistyössä',
  notFoundExperienceTitle: 'Tämä elämys ei ole enää saatavilla',
  notFoundExperienceSubtitle:
    'Se on saatettu poistaa julkaisusta tai linkki ei ole enää voimassa.',
  deadLinkRecoverySubtitle: 'Tutustu muihin varattaviin elämyksiin',
  viewAllExperiences: 'Näytä kaikki elämykset',
  experienceBenefits: {
    benefits: {
      basePointsEarn:
        '<p><strong>Ansaitse 5 peruspistettä</strong> jokaisesta käytetystä $1 USD, kun kirjaudut World of Hyatt -tilillesi varataksesi tämän elämyksen</p>',
      basePoints:
        '<p><strong>Ansaitse 10 peruspistettä</strong> jokaisesta käytetystä $1 USD, kun kirjaudut World of Hyatt -tilillesi varataksesi tämän elämyksen</p>',
      additionalBonusPoints:
        '<p><strong>Ansaitse 4 ylimääräistä bonuspistettä</strong> jokaisesta käytetystä $1 USD, kun varaat World of Hyatt -luottokortillasi</p>',
      additionalBonusPointsTier:
        '<p><strong>Ansaitse jopa 30% ylimääräisiä bonuspisteitä</strong> jäsentasostasi riippuen</p>',
      payWithPoints:
        '<p><strong>Maksa pisteillä</strong> varatessasi tämän elämyksen</p>',
    },
  },
};
